import { FC, useEffect, useState } from 'react';
import './ModalSectionsArticlesInsert.scss';
import ModalDefault from '../../../ModalDefault/ModalDefault';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAuth } from '../../../../providers/AuthProvider';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { Col, FormGroup, Row } from 'react-bootstrap';
import ErrorMessage from '../../../ErrorMessage/ErrorMessage';
import { schema } from './Validate';
import ReactSelect from "react-select";
import { useAgentsCategories } from '../../../../providers/Agents/AgentsCategories/AgentsCategoriesProvider';
import { customStyles } from '../../../../models/SelectCustomStyles';
import { useSections } from '../../../../providers/Articles/Sections/SectionsProvider';
import { SectionsModel } from '../../../../models/Articles/Sections/SectionsModel';

interface ModalSectionsArticlesInsertProps {
  show: boolean;
  selectedSection?: SectionsModel;
  onClose: () => void;
}

const ModalSectionsArticlesInsert: FC<ModalSectionsArticlesInsertProps> = ({ show, onClose, selectedSection }) => {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [selectedCategories, setSelectedCategories] = useState<any>();

  const { onInvalid } = useAuth();
  const { categoriesOptions } = useAgentsCategories();
  const { handleFetchSection, setError, handleListSections } = useSections();

  const { handleSubmit, register, setValue, reset, formState: { errors } } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const handleClose = () => {
    setError('');
    setValue("name", "");
    setValue("description", "");
    setValue("category_id", 0);
    setSelectedCategories({});
    onClose();
  }

  const onSubmit = async (data: any) => {
    setIsLoadingSubmit(true);
    setError('');

    if (selectedSection?.id && selectedSection?.id > 0) {
      const upt = {
        id: selectedSection?.id,
        name: data.name,
        description: data.description,
        category_id: data.category_id
      }

      const ret = await handleFetchSection(upt);

      if (ret) {
        toast.success('Seção alterada com sucesso!');
        handleListSections();
        onClose();
      }
    }
    else {
      const ret = await handleFetchSection(data as any);

      if (ret) {
        toast.success('Seção salva com sucesso!');
        handleListSections();
        onClose();
      }
    }

    setIsLoadingSubmit(false);
  }

  useEffect(() => {
    if (show) {
      if (selectedSection && selectedSection?.id && selectedSection?.id > 0) {
        setValue("name", selectedSection?.name ? selectedSection?.name : "");
        setValue("description", selectedSection?.description ? selectedSection?.description : "");
        setValue("category_id", selectedSection?.category?.id ? selectedSection?.category?.id : 0);
        setSelectedCategories({
          value: selectedSection?.category?.id,
          label: selectedSection?.category?.name
        });
      }
    }
    else {
      setValue("name", "");
      setValue("description", "");
      setValue("category_id", 0);
      setSelectedCategories({});
    }
  }, [show]);

  useEffect(() => {
    setValue('category_id', selectedCategories?.value || '');
  }, [selectedCategories]);

  useEffect(() => {
    if (selectedSection?.id && categoriesOptions?.length > 0) {
      setSelectedCategories(categoriesOptions.filter((item: any) => item.value === selectedSection?.category?.id)?.shift());
    }
  }, [categoriesOptions, selectedSection]);

  return (
    <ModalDefault
      title={"Adicionar Seções de Artigos"}
      show={show}
      onClose={handleClose}
      sizeModal={"lg"}
      showFooter={true}
      buttonText={isLoadingSubmit ? "Salvando..." : "Salvar"}
      showButtonSpinner={isLoadingSubmit}
      disabledSubmit={isLoadingSubmit}
      handleSubmit={handleSubmit(onSubmit)}
      backdrop="static"
      backgroundColor="#f8f9fa"
    >
      <div
        className="ModalSectionsArticlesInsert"
        data-testid="ModalSectionsArticlesInsert"
      >
        <Row>
          <Col md={8}>
            <FormGroup className="form-group">
              <label htmlFor="name">NOME *</label>
              <input
                className={`form-control ${onInvalid(errors?.name)}`}
                type="text"
                {...register("name")}
                onChange={(e: any) => setValue("name", e?.target?.value)}
              />
              <ErrorMessage
                name={"Nome"}
                type={errors?.name?.type?.toString()}
                min={3}
                max={100}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="form-group">
              <label htmlFor="name">CATEGORIA *</label>
              <ReactSelect
                isSearchable
                options={categoriesOptions}
                value={selectedCategories}
                placeholder="Selecione"
                className={`form-control p-0 ${onInvalid(errors?.category_id)}`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => {
                  setSelectedCategories(e)
                }}
              />
              <ErrorMessage
                name={"Categoria"}
                type={errors?.category_id?.type?.toString()}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup className="form-group">
              <label htmlFor="description">DESCRIÇÃO</label>
              <textarea
                rows={5}
                id="description"
                className={`form-control ${onInvalid(errors?.description)}`}
                {...register("description")}
              />
              <ErrorMessage
                name={"Descrição"}
                type={errors?.description?.type?.toString()}
                min={3}
                max={1000}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </ModalDefault>
  );
}

export default ModalSectionsArticlesInsert;
